/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * *

Swiper by iDangero.us

API:

http://idangero.us/swiper/api/

*/

import { initiSwiperInstances } from 'allink-core-static/js/modules/swiper';

$(function(){

    var options = {
        // define options here
        loop: false,
    };

    if ($('.slider-header-media').data('autoplay') === undefined) {
        options.loop = true;
    }

    // on page load
    initiSwiperInstances(options);

    // custom event
    $(window).on('initiSwiperInstances viewportWidthHasChanged', function() {
        initiSwiperInstances(options);
    });

      $(window).on('swiper:onSlideChangeStart', function (event, swiper, $swiperElement) {
        const activeIndex = swiper.realIndex + 1; // django loop index starts at 1
        const $sliderContents = $swiperElement.find('.swiper-content');
        const $activeContent = $swiperElement.find(`.swiper-content-${activeIndex}`);
        $sliderContents.removeClass('swiper-content--visible');
        $activeContent.addClass('swiper-content--visible');
    });

    /* * * * * * * * * * * * * * * * * * * * * * * * * * * * * *

    Full width

    */

    function initFullWidthSlider() {
        var $swiper_instances = $('.slider-fullwidth');
        // loop through instances
        $swiper_instances.each(function(){
            // init
            const $swiper_instance = $(this);
            // slider not visible? Adios!
            if ($swiper_instance.is(":visible") === false) {
                return true;
            }
            // instanciate buttons
            const $btn_next = $swiper_instance.find('.swiper-button-next');
            const $btn_prev = $swiper_instance.find('.swiper-button-prev');
            // instanciate swiper
            const mySwiper = new Swiper($swiper_instance, {
                // global settings
                onInit: function(swiper){
                    // leave a flag when an instance has been initialized in order to prevent re-initialization
                    $swiper_instance.addClass('swiper-initialized');
                    // trigger custom event
                    $(window).trigger('initInlineVideo');
                    $(window).trigger('slider-fullwidth:initialized');
                },
                onSlideChangeStart: function(swiper) {
                    $(window).trigger('slider-fullwidth:onSlideChangeStart');
                },
                onSlideChangeEnd: function(swiper) {
                    $(window).trigger('slider-fullwidth:onSlideChangeEnd');
                },
                effect: 'slide',
                centeredSlides: true,
                speed: 500, // Number: Duration of transition between slides (in ms)
                slidesPerView: 'auto',
                spaceBetween: 28, // analoge $grid-gutter-width
                direction: 'horizontal',
                loop: true, // important: Set to 'false' when scrollbar is enabled
                grabCursor: true,

                // If we need pagination
                pagination: '.swiper-pagination',
                paginationElement: 'span',
                paginationClickable: true,

                // Navigation arrows
                nextButton: $btn_next,
                prevButton: $btn_prev,
            });
        });
    }

    // on page load
    initFullWidthSlider();
    // when events are triggered
    $(window).on('initFullWidthSlider',function(){
        initFullWidthSlider();
    });

});



// WEBPACK FOOTER //
// ./static/js/modules/swiper.js